import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withPreloading,
} from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { accountingCompanyInterceptor } from './core/interceptors/accounting-company.interceptor';
import { CustomPreloadingStrategy } from './core/routing/custom-preloading.strategy';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withEnabledBlockingInitialNavigation(),
      withPreloading(CustomPreloadingStrategy),
    ),
    provideHttpClient(
      withFetch(),
      withInterceptors([authInterceptor, accountingCompanyInterceptor]),
    ),
  ]
};
